import {ViewChild, Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ColetorCustosService } from '../../_services/coletorCustos.service';
import { PagOdsOrdint } from '../../_models/PagOdsOrdint';
import { Message, User } from '../../_models';
import { Router } from '@angular/router';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

@Component({
  selector: 'lista-ordem-interna',
  templateUrl: './lista-ordem-interna.component.html',
  styleUrls: ['./lista-ordem-interna.component.css']
})
export class ListaOrdemInternaComponent implements OnInit {
  currentUser: User;
  messageModel: Message;
  lstPagOdsOrdint = new Array<PagOdsOrdint>();
  loadProtocolos = true;
  CarregarLista: boolean;

  constructor(
    private router: Router,
    private apiColetorCustos: ColetorCustosService,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ListaOrdemInternaComponent>,
    private dialog?: MatDialog
    ) { 
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }

    FormList: FormGroup;

  ngOnInit() {
    this.CarregarLista = false;
    this.CarregarValidacoesTela();
  }

  listar(){
    let descriao = this.FormList.controls['frmDescricao'].value;
    let empresa = this.FormList.controls['frmEmpresa'].value;
    let divisao = this.FormList.controls['frmDivisao'].value;
    this.CarregarLista = true;

    this.apiColetorCustos.ObterColetoresOrdemInterna("F", descriao, empresa, divisao)
      .subscribe(
        rtn => this.lstPagOdsOrdint = rtn.data,
        err => {
          console.log(err);
          this.messageModel = new Message(
            "Coletores de Custo",
            "Erro de conexão",
            "Ocorreu um erro ao listar os Coletores de Custo da base. Tente novamente.",
            "warning")
            this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
          this.loadProtocolos = false;
        },
        () => {
          console.log(this.lstPagOdsOrdint)
          this.dataSource = new MatTableDataSource<PagOdsOrdint>(this.lstPagOdsOrdint);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.loadProtocolos = false;
        }
      );
  }

  CarregarValidacoesTela() {
    // VALIDAÇÕES FORMULARIO 2. FICHA DO PROTOCOLO
    this.FormList = this.formBuilder.group({
      frmDescricao: ['', Validators.nullValidator],
      frmEmpresa: ['', Validators.nullValidator],
      frmDivisao: ['', Validators.nullValidator]
    });
  }

  NavigateProtocolo(codcencst: string) {
    this.dialogRef.close(codcencst);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  displayedColumns: string[] = ['numordint','desordint', 'codtipord', 'codcenlgt', 'codemp', 'coddiv', 'codcenlcr'];
  dataSource = new MatTableDataSource<PagOdsOrdint>(this.lstPagOdsOrdint);
  selection = new SelectionModel<PagOdsOrdint>(true, []);

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  closePopup(){
    this.dialogRef.close("");
  }

}
